import type { GalleryImageData } from '../_components/types';

export const galleryImagesOR4: GalleryImageData[] = [
  {
    alt: 'drafting_design_alt',
    src: 'career/careers-carousel-01',
  },
  {
    alt: 'design_hand_drafting_alt',
    src: 'career/careers-carousel-02',
  },
  {
    alt: 'small_and_large_alt',
    src: 'career/careers-carousel-03',
  },
  {
    alt: 'oura_ring_creamy_bg_alt',
    src: 'career/careers-carousel-04',
  },
];
